import { render, staticRenderFns } from "./AllInvoices.vue?vue&type=template&id=6ade5142&scoped=true"
import script from "./AllInvoices.vue?vue&type=script&lang=js"
export * from "./AllInvoices.vue?vue&type=script&lang=js"
import style0 from "./AllInvoices.vue?vue&type=style&index=0&id=6ade5142&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ade5142",
  null
  
)

export default component.exports